import React, { Fragment, useState } from 'react'
import { v4 as uuidv4 } from 'uuid';

const Formulario = ({crearCita}) => {

    const y ="👍";
    const b = "👎";

    //Crear Sate de Citas
    const [cita, actualizarCita]= useState({
        mascota:'',
        propietario:'',
        fecha: '',
        hora: '',
        sintomas: ''

    })

    //Otro State
    const [error,actualizarError] = useState(false)

    //📝Nota-4: El hook posee una variable y una funcion, la variable no debe modificarse directamnte, esta debe ser manejada a traves de su funcion y el valor de la variable del estate se declara con el useState(Variable)


    //Funcion que se qejecuta cuando el usuario excribe en el input
    const actualizarState= e =>{
       // console.log(e.target.value);
        /*📝Nota-2: Cuando se llama un evento, este posee informacion importantel del  que se esta llamando la funcion
        EJ: e.target.name(recibe el nombre declarado en el input),
        e.target.value(recibe el valor actual del imput)*/
        actualizarCita({
            // [...]📝 Nota-3 Spread Operator
           
            ...cita,
         
            [e.target.name]: e.target.value

            //Con la informacion de Spread Operator [...] y los e.target se Actualiza el state de los componentes a traves de los HOOKS
        })

        


    }
    //Cuando el usuario envia enl formulario

    const submitCita = e=>{
        e.preventDefault();
      
     
        
        //validar
        if (mascota.trim()==='' || propietario.trim()==='' || fecha.trim()==='' || hora.trim()==='' || sintomas.trim()==='' ) {
            console.log("Hay un Error"+b);
            
            actualizarError(true)
            
            return
        }
        console.log("Campos Validados Correctamente "+y);
        cita.id= uuidv4();
        
        

        //Eliminar el mensaje previo

        actualizarError(false);

        //Asignar ID
       // cita.id= cita.length+1;
       // console.log(cita);
        
        
        //Crear la Cita
            crearCita(cita)
        //Reiniciar el Form

        actualizarCita({
            mascota:'',
            propietario:'',
            fecha: '',
            hora: '',
            sintomas: ''
        })
        
        
        
    }

    const {mascota, propietario,fecha,hora, sintomas}= cita;
    

//---------------------------------------JSX------------------------------------------------
    return (
        <Fragment>
            <h1>Formulario 📝 </h1>

            {error?
            <p className="alerta-error">Todos los campos son obligatorias</p>:null

            }

            <form
            onSubmit={submitCita}
            >
                <label>Nombre Mascota</label>
                <input
                    type="text"
                    name="mascota"
                    className="u-full-width"
                    placeholder="Nombre Mascota"
                    onChange={actualizarState}
                    value={mascota}
                    //Nota-1:Para Comunicar un input con react se utiliza la funcion onChange invovando una funcion
                />


                <label>Nombre del dueño</label>
                <input
                    type="text"
                    name="propietario"
                    className="u-full-width"
                    placeholder="Nombre del Dueño de la Mascota"
                    onChange={actualizarState}
                    value={propietario}
                />

                <label>Fecha</label>
                <input
                    type="date"
                    name="fecha"
                    className="u-full-width"
                    onChange={actualizarState}
                    value={fecha}

                />


                <label>Hora</label>
                <input
                    type="time"
                    name="hora"
                    className="u-full-width"
                    onChange={actualizarState}
                    value={hora}

                />
           

            <label>Sintomas</label>
            <textarea   className="u-full-width" name="sintomas" onChange={actualizarState}  value={sintomas}>
            </textarea>

            <button type="submit"  className="u-full-width button-primary">Agregar Cita</button>
            </form>


        </Fragment>






    );
}

export default Formulario;